import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavegate } from 'App/hooks';
import NuvemAppPage from 'domains/PartnersApps/pages/NuvemAppPage';

export function MarketingAutomationPage() {
  const { pathname, goTo } = useNavegate();
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash.includes('/automations')) {
      goTo(`${pathname}#/automations`);
    }
  }, [pathname, goTo, hash]);

  return <NuvemAppPage code="marketing-automation" />;
}
